import { ComponentCO2 } from '@acies/domain';
import { ObservableCollection } from '@acies/observables';
import { InputFieldEvent } from '@acies/ui';
import CO2Model from '../models/co2-model';
import FilterComponentCO2Model from '../models/filter-component-co2-model';

export default class FilterComponentCO2Controller {
	#co2Collection: ObservableCollection<ComponentCO2>;
	#filterComponentCO2Model: FilterComponentCO2Model;
	public constructor(co2Model: CO2Model) {
		this.#co2Collection = co2Model.listComponentCO2Model.co2Collection;
		this.#filterComponentCO2Model = co2Model.filterComponentCO2Model;
		this.#co2Collection.subscribe(this.#collectionUpdated.bind(this));
	}

	/** We pass on the text value of the Event to the model that updates the filter. */
	public filterInputChanged(event: Event): void {
		if (event instanceof InputFieldEvent) {
			this.#filterComponentCO2Model.filter = event.text;
			this.#filterComponentCO2Model.filterInputText = event.text;
		}
	}

	/** If the co2Collection doesn't contain any items, because it hasn't loaded yet, clear and disable the filter InputField, otherwise enable the InputField. */
	#collectionUpdated(): void {
		if (!this.#co2Collection.containsUnfilteredItems) {
			this.#co2Collection.filter = '';
			this.#filterComponentCO2Model.filterInputText = '';
			this.#filterComponentCO2Model.filterInputEnabled = false;
		} else {
			this.#filterComponentCO2Model.filterInputEnabled = true;
		}
	}
}
